import actions from './actions';
import { DataService } from '../../../config/dataService/dataService';
import { TipoReporteCorteCaja } from '../../../config/api/enums';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const { 
  corteCajaList,   
} = actions;

const corteCajaListAction = (dia = '', tipoReporte = TipoReporteCorteCaja.PorCajero) => {
  return async dispatch => {
    try {
      const response = await DataService.get('/reportes/corteDelDia.php?dia=' + dia + '&tipoReporte=' + tipoReporte);
      if (response.status === 200 && response.data.data) {                
        dispatch(corteCajaList(response.data.data));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

export {
  corteCajaListAction  
};
